import axios from 'axios';
import _get from 'lodash/get';
import * as types from '../constants/ActionTypes';
import Page from '../../lib/page';
import getFaqList, { requestArticles } from './action-faq-list';
import { updateL1TopicDetails } from './action-L3Topic-list';
import { isNewExpLayoutEnabled } from '../../../jsV2/helpers/twHelper';
import topicTreeJSONData from '../../../../server/data/topicTree/topicTree.json';

const WEBTOPICTREE = '/smarthelp/web-topic-tree';

function requestTopicTree() {
  return {
    type: types.REQUEST_TOPIC_TREE,
    payload: undefined,
  };
}

function receiveTopicTree(response, experience) {
  const topics = _get(response, 'webTopicTree');
  const blacklistedMarketICFFlag = _get(response, 'blacklistedMarketICFFlag' || false);
  return {
    type: types.RESPONSE_TOPIC_TREE,
    payload: {
      topics,
      experience,
      blacklistedMarketICFFlag,
    },
  };
}
function receiveTopicTreeError() {
  return {
    type: types.ERROR_TOPIC_TREE,
    payload: undefined,
  };
}

// Update with topics, experience and blacklistedMarketICFFlag
export function updateL2TopicTree(params) {
  return {
    type: types.UPDATE_L2_TOPICS,
    payload: params,
  };
}

export function updateTopicTree(response, experience) {
  const L2subTopics = _get(response, 'webTopicTree');
  const topics = L2subTopics.map(({ subTopicId, subTopicName, articles }) => ({
    topicId: subTopicId,
    topicName: subTopicName,
    faqList: articles,
  }));
  const blacklistedMarketICFFlag = _get(response, 'blacklistedMarketICFFlag' || false);
  return {
    type: types.RESPONSE_TOPIC_TREE,
    payload: {
      topics,
      experience,
      blacklistedMarketICFFlag,
    },
  };
}

export default function fetchTopicTree(experience, topicSelected, isL2TopicSelected = false) {
  return (dispatch) => {
    if (isNewExpLayoutEnabled()) {
      const topicTreeJson = topicTreeJSONData;
      return Promise.resolve(topicTreeJson).then((data) => dispatch(receiveTopicTree(data, experience)));
    }
    dispatch(requestTopicTree());
    const url = Page.setChannelForTechnicalExp(WEBTOPICTREE);
    if (isL2TopicSelected) {
      dispatch(requestArticles());
    }
    return axios
      .get(url)
      .then((response) => {
        if (isL2TopicSelected) {
          const res = response.data && response.data.webTopicTree;
          if (Array.isArray(res) && res.length) {
            const selectedL1Topic = res.find((topic) => topic.topicId === topicSelected);
            dispatch(updateL1TopicDetails(selectedL1Topic, res));
            dispatch(getFaqList(res, topicSelected, true));
          }
        }
        return dispatch(receiveTopicTree(response.data, experience));
      })
      .catch(() => dispatch(receiveTopicTreeError()));
  };
}
